import React from 'react';
import Plotly, {LayoutAxis} from "plotly.js";
import Plot from "react-plotly.js";
import {getChartSizeValue} from "utils/utils";
import {PlotDataEx} from "components/dashboard/charts/interfaces";

const commonAxisConfig = {
    showspikes: true,
    spikemode: "toaxis",
    automargin: true
} as Partial<LayoutAxis>

const layoutConfig = {
    legend: {
        orientation: "h"
    },
    margin: {
        l: 0,
        r: 0,
        b: 0,
        t: 20,
    }
} as unknown as Plotly.Layout

type DatasetBarChartProps = {
    data: PlotDataEx[]
    width: number,
    height: number | string,
    dateFormat?: string
    chartConfig?: any
}

const DatasetBarChart = ({data, width, height, dateFormat, chartConfig}: DatasetBarChartProps) => {
    if (data.length === 0) {
        return <h2 className="flex justify-content-center">No data</h2>
    }
    const unit = data[0].unit||"";
    return <Plot data={[...data]}
                 className="ea-plotly-bar-chart"
                 config={chartConfig}
                 layout={{
                     ...layoutConfig,
                     width,
                     height: getChartSizeValue(height),
                     xaxis: {
                         showticklabels: true,
                         tickformat: dateFormat || '%Y-%m-%d %H:%M:%S',
                         type: "date",
                         ...commonAxisConfig
                     },
                     yaxis: {
                         showticklabels: true,
                         title: {
                             text: unit,
                             standoff: 10
                         },
                         tickformat: 'f',
                         ...commonAxisConfig
                     },
                     showlegend: true,
                     barmode: 'group',
                     bargroupgap: 0.1
                 }}
    />
}

export default DatasetBarChart;